/**
 * These tags are used to track analytics data for <a> elements in various store components.
 */
export const STORE_DETAILS_EXPERIENTIAL = "store-details-experiential";

export const STORE_DETAILS_REGULAR = "store-details-regular";

export const STORE_SPACES_SUMMARY = "store-spaces-summary";

export const CLASSES_EVENTS = "classes-events";

export const MAILING_LIST_SIGNUP = "mailing-list-signup";

export const STORE_TOP_SELLERS_BANNER = "store_top_sellers_banner";

export const SOCIAL = "social";

export const STORE_SPACE_DETAILS_EXPERIENTIAL =
  "store-space-details-experiential";
